<app-mobile-header-secondary title="{{ 'menu.customization' | translate }}"></app-mobile-header-secondary>

@if (contextMenu === contextMenuState.domainName) {
  <app-whitelabel-domain-name [whitelabelData]="whitelabelData" (contextChange)="changeContext($event)" style="padding: 0" [currentUser]="currentUser" (goBack)="goBack(contextMenuState.default)">
  </app-whitelabel-domain-name>
}
@if (contextMenu === contextMenuState.emailAddress) {
  <app-whitelabel-email-adress
    [whitelabelData]="whitelabelData"
    (contextChange)="changeContext($event)"
    style="padding: 0"
    [currentUser]="currentUser"
    [sendgridDns]="sendgridDns"
    (goBack)="goBack(contextMenuState.default)"
  >
  </app-whitelabel-email-adress>
}
@if (contextMenu === contextMenuState.signingPage) {
  <app-whitelabel-signing-page
    (contextChange)="changeContext($event)"
    (goBack)="goBack(contextMenuState.default)"
    [whitelabelData]="whitelabelData"
    [mainColor]="whitelabelData.main_color || whitelabelService.mainColor"
    style="padding: 0"
    [currentUser]="currentUser"
  ></app-whitelabel-signing-page>
}
@if (contextMenu === contextMenuState.signedDocument) {
  <app-whitelabel-signed-document
    (contextChange)="changeContext($event)"
    (goBack)="goBack(contextMenuState.default)"
    [whitelabelData]="whitelabelData"
    style="padding: 0"
    [currentUser]="currentUser"
  ></app-whitelabel-signed-document>
}
@if (contextMenu === contextMenuState.default) {
  <div class="d-flex flex-column flex-xl-row">
    <div class="configuration-plans-row">
      @if (currentUser) {
        <article class="mb-4">
          <div class="configuration-container">
            <div class="configuration-content">
              <p class="configuration-title">
                {{ 'whitelabel.customizeURL' | translate }} <span class="highlight">{{ currentUser?.organization?.name || ('whitelabel.organization' | translate) }}</span>
              </p>
              <p class="configuration-text">{{ 'whitelabel.urlCustomizationExplanation' | translate }}</p>
              <div class="container-submenu">
                <div class="submenu-background">
                  <div class="submenu">
                    <div [loadingAnimation]="isLoading" class="submenu-name">
                      <p class="submenu-name-title">{{ 'whitelabel.subdomainInAutentique' | translate }}</p>
                      @if (!isLoading) {
                        <p class="submenu-name-description">{{ whitelabelData?.domain || 'acme.autentique.com.br' }}</p>
                      }
                    </div>
                    <div class="submenu-button" (click)="changeContext(contextMenuState?.domainName)">
                      <p class="submenu-button-text">{{ 'button.edit' | translate }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      }
      @if (currentUser?.currentPermissions.change_whitelabel_oz) {
        <article class="mb-4">
          <div class="configuration-container">
            <div class="configuration-content">
              <p class="configuration-title">{{ 'whitelabel.customizeEmailSendingAddress' | translate }}</p>
              <p class="configuration-text" [innerHTML]="'whitelabel.useYourOwnEmail' | translate"></p>
              <div class="submenu-background">
                <div class="submenu">
                  <div [loadingAnimation]="isLoading" class="submenu-name">
                    <p class="submenu-name-title">{{ 'whitelabel.senderDomain' | translate }}</p>
                    @if (!isLoading) {
                      <p class="submenu-name-description">{{ whitelabelData?.sendgrid_domain || 'sign.acme.com' }}</p>
                    }
                  </div>
                  <div class="submenu-button" (click)="changeContext(contextMenuState.emailAddress)">
                    <p class="submenu-button-text">{{ 'button.edit' | translate }}</p>
                  </div>
                </div>
                <div class="submenu pt-2">
                  <div [loadingAnimation]="isLoading" class="submenu-name">
                    <p class="submenu-name-title">{{ 'whitelabel.sendingEmailAddress' | translate }}</p>
                    @if (!isLoading) {
                      <p class="submenu-name-description">
                        {{ whitelabelData?.sendgrid_email_user || ('whitelabel.signature' | translate) }}&#64;{{ whitelabelData?.sendgrid_domain || 'sign.acme.com' }}
                      </p>
                    }
                  </div>
                </div>
                <div class="submenu pt-2">
                  @if (sendgridDns) {
                    <div class="submenu-name">
                      <p class="submenu-name-title">{{ 'whitelabel.DNSRecords' | translate }}</p>
                      @for (dns of sendgridDns?.dns; track dns) {
                        <p class="submenu-name-description">
                          {{ dns.host }}
                          <i class="fa-regular fa-{{ dns.valid ? 'check-circle green' : 'times-circle red' }}"></i>
                        </p>
                      }
                    </div>
                  } @else {
                    <div [loadingAnimation]="isLoading" class="submenu-name">
                      <p class="submenu-name-title">{{ 'whitelabel.DNSRecords' | translate }}</p>
                      @if (!isLoading) {
                        <p class="submenu-name-description">sign.acme.com <i class="fa-regular fa-check-circle green"></i></p>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </article>
      }
      @if (currentUser?.currentPermissions.change_whitelabel_oz) {
        <article class="mb-4">
          <div class="configuration-container">
            <div class="configuration-content">
              <p class="configuration-title">Open Graph</p>
              <p class="configuration-text">{{ 'whitelabel.defineTheImageForOpenGraph' | translate }}</p>
              <div class="container-submenu">
                <div class="submenu-background">
                  <div class="submenu">
                    <div [loadingAnimation]="isLoading" class="submenu-name">
                      <p class="submenu-name-title">{{ 'whitelabel.image' | translate }}</p>
                      @if (!isLoading) {
                        <p class="submenu-name-description">{{ whitelabelData?.og_image || 'https://acme.com/logo.png' }}</p>
                      }
                    </div>
                    <div class="submenu-button" (click)="openEditOpengraphModal()">
                      <p class="submenu-button-text">{{ 'button.edit' | translate }}</p>
                    </div>
                  </div>
                  <div class="submenu pt-2">
                    <div [loadingAnimation]="isLoading" class="submenu-name">
                      <p class="submenu-name-title">{{ 'whitelabel.title' | translate }}</p>
                      @if (!isLoading) {
                        <p class="submenu-name-description">{{ whitelabelData?.og_title || 'ACME sign' }}</p>
                      }
                    </div>
                  </div>
                  <div class="submenu pt-2">
                    <div [loadingAnimation]="isLoading" class="submenu-name">
                      <p class="submenu-name-title">{{ 'whitelabel.description' | translate }}</p>
                      @if (!isLoading) {
                        <p class="submenu-name-description">{{ whitelabelData?.og_description || 'whitelabel.signWithAcme' | translate }}</p>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      }
      @if (currentUser?.currentPermissions.change_whitelabel_oz) {
        <article class="mb-4">
          <div class="configuration-container">
            <div class="configuration-content headerFlex">
              <div>
                <p class="configuration-title">{{ 'whitelabel.customizeSignaturePage' | translate }}</p>
                <p class="configuration-text">{{ 'whitelabel.customizeSignaturePageDescription' | translate }}</p>
              </div>
              <div class="configuration-generate" (click)="changeContext(contextMenuState.signingPage)">
                <button type="button" class="configuration-button">{{ 'button.edit' | translate }}</button>
              </div>
            </div>
          </div>
          @if (!isLoading) {
            <div class="pageSize">
              <app-signing-page [whitelabelData]="whitelabelData" [isDarkmode]="isDarkmode"></app-signing-page>
            </div>
          }
        </article>
      }
    </div>

    <div class="configuration-plans-row">
      @if (currentUser?.currentPermissions.change_whitelabel_oz) {
        <article class="mb-4">
          <div class="configuration-container">
            <div class="configuration-content headerFlex">
              <div>
                <p class="configuration-title">{{ 'whitelabel.customizeSignedDocument' | translate }}</p>
                <p class="configuration-text">{{ 'whitelabel.customizeSignedDocumentDescription' | translate }}</p>
              </div>
              <div class="configuration-generate">
                <button type="button" class="configuration-button" (click)="changeContext(contextMenuState.signedDocument)">{{ 'button.edit' | translate }}</button>
              </div>
            </div>
          </div>
          @if (!isLoading) {
            <div class="pageSize">
              <app-signed-document [whitelabelData]="whitelabelData"></app-signed-document>
            </div>
          }
        </article>
      }
    </div>
  </div>
}
